/** @format */
import { SearchFacet } from '@toucan/common/services/search/constants';
import { SelectedFilters } from '@toucan/common/services/search/types';

import { ActiveFilter } from '@toucan/client/features/search/components/model-search-results/components/filters/types';
import {
    Filter,
    FilterOption,
} from '@toucan/client/features/search/components/model-search-results/types';

function transformFilterQueryToActiveFilters(
    filter: Filter,
    selectedValue: string | string[] | number | boolean
): ActiveFilter {
    const filterOption = filter.values.find(
        ({ value: itemValue }) =>
            itemValue.toString() === selectedValue.toString()
    );

    return {
        id: filter.id,
        title: filter.label,
        label: filterOption?.label ?? '',
        value: selectedValue.toString(),
    };
}

function findFilterById(
    filters: Filter[],
    filterId: SearchFacet
): Filter | undefined {
    return filters.find((filter) => filter.id === filterId);
}

function createActiveFiltersForValues(
    filter: Filter,
    selectedValues: string | string[] | number | boolean
): ActiveFilter[] {
    if (Array.isArray(selectedValues)) {
        return selectedValues.map((selectedValue) =>
            transformFilterQueryToActiveFilters(filter, selectedValue)
        );
    }

    return [transformFilterQueryToActiveFilters(filter, selectedValues)];
}

export function getActiveFilters(
    filters: Filter[],
    selectedFilters: SelectedFilters
): ActiveFilter[] {
    const selectedFiltersEntries = Object.entries(selectedFilters);

    return selectedFiltersEntries.reduce(
        (activeFilters, [filterId, selectedValues]) => {
            const filter = findFilterById(filters, filterId as SearchFacet);

            if (!filter) {
                return activeFilters;
            }

            const processedActiveFilters = createActiveFiltersForValues(
                filter,
                selectedValues
            );

            return [...activeFilters, ...processedActiveFilters];
        },
        [] as ActiveFilter[]
    );
}

export function getSelectedItemsAfterRemovalOfActiveFilter(
    activeFilter: ActiveFilter,
    selectedFilters: SelectedFilters
): FilterOption[] {
    const currentSelectedItems = selectedFilters[activeFilter.id];

    if (!Array.isArray(currentSelectedItems)) {
        return [];
    }

    return currentSelectedItems.reduce<FilterOption[]>(
        (selectedItems, item) => {
            const isFilterToRemove = item === activeFilter.value;

            if (!isFilterToRemove) {
                selectedItems.push({
                    label: activeFilter.label,
                    value: item.toString(),
                });
            }

            return selectedItems;
        },
        []
    );
}
